<template>
  <div class="modal_generic" :class="cls">
    <div class="modal_dimmer_generic" @click="dimmerClose()"></div>
      <div class="modal_popup_generic">
        
        <slot />

        <div class="close-btn" @click="killerClose()">X</div>
      </div>
  </div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
export default {
  components: {  },
  props: [ 'visible', 'no-dimmer-close', 'cls' ],
  mixins: [ mixins.db, mixins.generic ],
  data: function () { return {
      
  } },
  computed: {

    

  },
  methods: {

    dimmerClose(){
      if( this.noDimmerClose ) return
      this.$emit('close')
    },

    killerClose(){
      this.$emit('close')
    },

  },
  created(){

    

  },

}
</script>



// WEBPACK FOOTER //
// Modal.vue?3e9859e2